import React, { useEffect, useState } from 'react';
import Footer from 'components/elements/footer';
import { HomeArticle, HomeCertification, HomeMethod, HomeRegister, HomeService, HomeSlide } from 'modules/page/home';
import MetaTags from 'react-meta-tags';
import { useTranslation } from 'react-i18next';
import EnabledDeveloperTools from 'components/common/deverloper-tools/enabled-developer-tools';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import useThemeWithPartner from 'hooks/useThemeWithPartner';
import WorkplazeThemeHideElement from 'components/elements/workplaze-theme-hide-element';
import { MenuBox, Navigation } from 'components/common/navigation';
import IconConfigWithTheme from 'components/common/icon-config-with-theme';
import usePageContext from 'hooks/usePageContext';
import { HomeWrapper } from './Home.styled';

function Home() {
    const { t, i18n } = useTranslation(['home', 'navigation']);
    const { auth } = useAuth();
    const [searchParams] = useSearchParams();
    const { voucher } = useParams();
    const location = useLocation();
    const theme = useThemeWithPartner();
    const { setPageLoaded } = usePageContext();

    //
    const [language, setLanguage] = useState<string>(i18n.language);

    useEffect(() => {
        const checkSwitchLanguage = () => {
            if (i18n.language !== language) {
                setPageLoaded(false);
                window.location.reload();
            }

            setLanguage(i18n.language);
        };

        checkSwitchLanguage();
    }, [i18n.language]);

    useEffect(() => {
        const init = () => {
            const token = auth.accessToken;
            const pathname = location.pathname;
            const source = searchParams.get('source');

            if (pathname.includes('/home/tlp') && voucher) {
                window.location.assign('line://app/' + process.env.REACT_APP_LIFF_APPID_CLAIM_TLP + '?voucher=' + voucher);
            }
            // else if (pathname.includes('/home/tlm') && voucher) {
            //     window.location.assign('line://app/' + process.env.REACT_APP_LIFF_APPID_CLAIM_TLM + '?voucher=' + voucher);
            // } else if (pathname.includes('/home') && voucher) {
            //     window.location.assign('line://app/' + process.env.REACT_APP_LIFF_APPID_CLAIM_TLP + '?voucher=' + voucher);
            // }
            /** 
            else if (pathname === '/' && (isMobile || isAndroid || isIOS) && !token && source !== 'liff') {
                window.location.assign('line://app/' + process.env.REACT_APP_LIFF_APPID_HOME)
            }
            **/
        };

        init();
    }, []);

    return (
        <React.Fragment>
            <MetaTags>
                <title>ร้านขายยาออนไลน์ พร้อมบริการจัดส่งยาถึงบ้านคุณ &#9168; PharmCare</title>
                <meta
                    name='description'
                    content='PharmCare เครือข่ายร้านขายยาคุณภาพใกล้ฉัน กว่า 4,300 แห่ง ให้บริการปรึกษาเภสัชกร สั่งซื้อยาออนไลน์ และจัดส่งถึงบ้านภายใน 1 ชม. พร้อมดูแลคุณทั่วประเทศไทย 
'
                />
                <meta name='robots' content='index,follow' />
                <link rel='canonical' href='https://app.pharmcare.co/' />
                <link rel='alternate' href='https://app.pharmcare.co/' hrefLang='th-TH' />
                <meta property='og:url' content={`${process.env.REACT_APP_WEB_URL}/`} />
            </MetaTags>

            <div className='home'>
                <EnabledDeveloperTools />
                <HomeSlide />
                <HomeService />
                <HomeWrapper>
                    <div className='home-box'>
                        <h2 className='home-title'>คุณสมบัติเด่นของแพลตฟอร์ม</h2>
                        <p className='home-detail'>
                            PharmCare เป็นแพลตฟอร์มร้านยาออนไลน์ ที่ให้บริการสั่งยาส่งถึงบ้าน
                            พร้อมให้คำปรึกษาทางการแพทย์แก่ผู้ป่วยเรื่องการใช้ยา หรือปัญหาสุขภาพต่าง ๆ
                            ซึ่งมีความโดดเด่นด้านการให้บริการที่ช่วยยกระดับคุณภาพชีวิตในหลากหลายประการ ดังนี้
                        </p>
                        <ul className='home-detail'>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>สะดวกและรวดเร็ว</b> สั่งซื้อยาออนไลน์ได้ทุกที่
                                ไม่ต้องเสียเวลาเดินทางไปร้านขายยา
                            </li>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>บริการจัดส่งทั่วประเทศ</b> ภายในพื้นที่กรุงเทพฯ
                                และปริมณฑลรับยาได้ภายใน 1 ชั่วโมง
                            </li>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>เภสัชกรผู้ชำนาญการ</b>{' '}
                                ให้คำปรึกษาและแนะนำการใช้ยาที่ถูกต้องและปลอดภัย
                            </li>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>สินค้าหลากหลาย</b> มีให้เลือกมากมาย ทั้งผลิตภัณฑ์ยา อาหารเสริม
                                ครบทุกความต้องการด้านสุขภาพ
                            </li>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>ระบบรักษาความปลอดภัย</b>{' '}
                                มั่นใจได้ในความปลอดภัยของข้อมูลส่วนตัวและการสั่งซื้อยา
                            </li>
                            <li>
                                <b style={{ color: 'var(--green-3)' }}>บริการครบวงจร</b> ทั้งการปรึกษา การสั่งซื้อ และการจัดส่ง
                                ในแพลตฟอร์มเดียว
                            </li>
                        </ul>
                        <p className='home-detail'>
                            ไม่ว่าคุณจะอยู่ในกรุงเทพฯ หรือต่างจังหวัด PharmCare พร้อมเป็นร้านขายยาออนไลน์ที่อยู่เคียงข้างคุณ
                            โดยสามารถเข้าถึงยาและคำแนะนำด้านสุขภาพที่มีคุณภาพได้อย่างทันท่วงที
                        </p>
                    </div>
                </HomeWrapper>

                <HomeArticle />
                <HomeMethod />
                <HomeCertification />
                <HomeRegister />
            </div>
            <Footer />
            {theme.name !== 'betterperiod' && (
                <WorkplazeThemeHideElement>
                    <Navigation>
                        {!['bilaxten'].some((f) => f === theme.name) && (
                            <MenuBox
                                to='/'
                                tag='/'
                                title={t('navigation:home')}
                                icon={<IconConfigWithTheme pageName='navigation' iconName='home' />}
                            />
                        )}

                        {!['mtl', 'default_oceanopd'].some((f) => f === theme.name) && (
                            <MenuBox
                                to='/phr/existing'
                                tag='/phr'
                                title={t('navigation:health_record')}
                                icon={<IconConfigWithTheme pageName='navigation' iconName='phr' />}
                            />
                        )}
                        <MenuBox
                            to='/service'
                            tag='/service'
                            title={t('navigation:acitivites')}
                            icon={<IconConfigWithTheme pageName='navigation' iconName='service' />}
                        />
                    </Navigation>
                </WorkplazeThemeHideElement>
            )}
        </React.Fragment>
    );
}

export default Home;
